<template>
  <div>
    
  </div>
</template>

<script>
export default {
  name: 'YoWalletFrontForgotPassword',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>